import { Chance } from 'chance';
import { times } from 'ramda';

import { Person } from './person';

export const generatePerson = (): Person => {
  const lastName = chance.last().toLocaleLowerCase();
  const firstName = chance.first().toLocaleLowerCase();

  const name = `${firstName} ${lastName}`;
  return {
    id: chance.guid(),
    firstName,
    lastName,
    name,
    age: chance.age(),
    email: chance.email(),
    salary: chance.natural({ min: 20000, max: 100000 }),
    profession: chance.pickone(professionSet),
    hobbies: chance.pickset(hobbiesSet, chance.natural({ min: 1, max: 4 })),
    country: chance.pickone(countrySet),
  }
}

export const generatePersons = (n: number) => times(generatePerson, n);

const chance = new Chance();

const countrySet = [
  "Algeria",
  "Argentina",
  "Australia",
  "Austria",
  "Belgium",
  "Brazil",
  "Cameroon",
  "Canada",
  "Chile",
  "China",
  "Colombia",
  "Croatia",
  "Czech Republic",
  "Denmark",
  "Egypt",
  "Estonia",
  "Finland",
  "France",
  "Georgia",
  "Germany",
  "Greece",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kenya",
  "Laos",
  "Latvia",
  "Lebanon",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Malta",
  "Mexico",
  "Morocco",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Norway",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Senegal",
  "Singapore",
  "South Africa",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Tanzania",
  "Thailand",
  "Tunisia",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Venezuela",
  "Vietnam",
];

const hobbiesSet = [
  "Football",
  "Swimming",
  "Singing",
  "Painting",
  "Writing",
  "Reading",
  "Hiking",
  "Cycling",
  "Trekking",
  "Basketball",
  "Tennis",
  "Guitar",
  "Movies",
  "Netflix",
  "Skiing",
  "Running"
];

const professionSet = [
  "Account Executive",
  "Accountant",
  "Acquisition Analyst",
  "Actor",
  "Aerospace Engineer",
  "Airline Pilot",
  "Appraiser",
  "Architect",
  "Baker",
  "Biologist",
  "Building Manager",
  "Business Analyst",
  "Chef",
  "Chemist",
  "Chief Executive Officer",
  "Chief Information Officer",
  "Chief Technology Officer",
  "Communications Director",
  "Computer Engineer",
  "Construction Engineer",
  "Consumer Relations Manager",
  "Credit Analyst",
  "Cryptologist",
  "Customer Service Manager",
  "Dentist",
  "Design Engineer",
  "Dietitian",
  "Economist",
  "Editor",
  "Electrical Engineer",
  "Film Producer",
  "Financial Analyst",
  "Flight Attendant",
  "Geologist",
  "Graphic Designer",
  "Health Therapist",
  "Hotel Manager",
  "Human Resources Manager",
  "IT Architect",
  "Industrial Engineer",
  "Interior Decorator",
  "Investment Banker",
  "Jeweler",
  "Journalist",
  "Lawyer",
  "Mathematician",
  "Mechanic",
  "Meteorologist",
  "Microbiologist",
  "Musician",
  "Network Administrator",
  "Nuclear Engineer",
  "Nutritionist",
  "Pharmacist",
  "Physician",
  "Private Investigator",
  "Professional Coach",
  "Quality Assurance Specialist",
  "Real Estate Broker",
  "Recruiter",
  "Reporter",
  "Restaurant Manager",
  "Retail Store Manager",
  "Risk Analyst",
  "Safety Engineer",
  "Sales Representative",
  "Security Consultant",
  "Singer",
  "Social Worker",
  "Software Engineer",
  "Statistician",
  "Stockbroker",
  "Tax Specialist",
  "Teacher",
  "Technical Writer",
  "Telemarketer",
  "Treasurer",
  "Urban Planner",
  "Veterinarian",
]